@if (available()) {
<ksg-button
  variant="text"
  iconOnly
  rounded
  icon="pi-compass"
  (click)="start()"
  [ksgTooltip]="'tour.start' | transloco"
  ksgTooltipPosition="bottom"
  [ariaLabel]="'tour.start' | transloco"
/>
}
